// Mirrors backend `OpenAIMessageToolType` enum. Backend sends/expects
// the snake_case string variants (`code_interpreter`, `file_search`,
// `web_search`, `image_generation`, `mcp`, `function`, `shell`,
// `automy_internal_mcp`, `automy_internal_function_aitodo`,
// `automy_internal_function_fileresources`);
// `convertEnumMemberToNumeric` in
// `add-ai-agent/utils/transformations.js` normalises both sides
// (strips `_`/`-`, lowercases) before matching, so PascalCase keys
// here are sufficient.
//
// The `AutomyInternal*` values (100+) are intentionally outside the
// 1..7 range so the backend can add more standard tools without
// colliding with the Automy-specific bucket. Keep the numeric values in
// sync verbatim or existing agent configs will misread their saved
// `allowedTools`.
export default Object.freeze({
  CodeInterpreter: 1,
  FileSearch: 2,
  WebSearch: 3,
  ImageGeneration: 4,
  Mcp: 5,
  Function: 6,
  Shell: 7,
  AutomyInternalMcp: 100,
  AutomyInternalFunctionAITodo: 101,
  // Backend C# member is `AutomyInternalFunctionPrepareFileResources` but its
  // EnumMember value is `automy_internal_function_fileresources` (no "prepare").
  // The wire value is the EnumMember string, and `convertEnumMemberToNumeric`
  // normalises by stripping `_`/`-` + lowercasing, so the JS key must omit
  // "Prepare" to round-trip correctly (→ `automyinternalfunctionfileresources`).
  AutomyInternalFunctionFileResources: 102,
});
